export default __webpack_public_path__ + "static/P_SearchThumb_SecuritySpy-cfe454641dc7158dd924555f681bd806.webp";